import React from 'react'
import Permission from '../../admin/Permission'
import V3DataRouteShell from '../data/V3DataRouteShell'

export default function V3PermissionsPage() {
  return (
    <V3DataRouteShell>
      <Permission />
    </V3DataRouteShell>
  )
}

